import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import AboutModal from './AboutModal';

// Create a global variable to store the About modal state setter
let globalSetAboutModalOpen = null;

// Function to be called from other components
export const openAboutModal = () => {
  if (globalSetAboutModalOpen) {
    globalSetAboutModalOpen(true);
  }
};

/**
 * TopNav Component
 * 
 * Exactly matches the legacy site's top navigation structure
 */
const TopNav = () => {
  // State to control the visibility of the About modal
  const [isAboutModalOpen, setIsAboutModalOpen] = useState(false);

  // Store the setter in the global variable
  useEffect(() => {
    globalSetAboutModalOpen = setIsAboutModalOpen;
    return () => {
      globalSetAboutModalOpen = null;
    };
  }, []);

  // Handler for the About link click
  const handleAboutClick = (e) => {
    e.preventDefault();
    setIsAboutModalOpen(true);
  };

  return (
    <>
      <div className="topnav"> 
        <ul>
          <li className="link"><a href="http://marc.ly">Portfolio</a></li>
          <li className="link"><Link to="/">R&D Toolkit</Link></li>
          <li className="link" id="myBtn"><a href="#" onClick={handleAboutClick}>About</a></li>
        </ul>
      </div>

      {/* Include the AboutModal component */}
      <AboutModal 
        isOpen={isAboutModalOpen} 
        onClose={() => setIsAboutModalOpen(false)}
      />
    </>
  );
};

export default TopNav; 